// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-navigation',
    // #endregion
    // #region Props
    props: {
        menuName: {
            type: String,
            required: false,
        },
    },
    // #endregion
    // #region Data
    data: () => ({
        _menu: null
    }),
    // #endregion
    // #region Created
    async created() {
        this.loadMenu();
    },
    // #endregion
    // #region Computed
    watch: {
        'menuName': function (newValue, oldValue) {
            this.loadMenu();
        },
    },
    // #endregion
    // #endregion Methods
    methods: {
        async loadMenu() {
            if (!this.menuName) {
                return;
            }
            this._menu = await this.$appHost.store.getter("navigation/getCachedMenu", this.menuName);
        }
    }
    // #endregion
});
// #endregion
